import React, { useEffect, useState } from "react";

import spiralBG from "images/fundraising/referral-background.png";
import LocationIcon from "images/icons/location-icon.inline.svg";
import ShareIcon from "images/icons/share-icon.inline.svg";
import LeafBg from "images/leaf-bg.png";

import { useBreakpoint } from "../../hooks/useBreakpoint";
import { getSourceImageUrlToCGI } from "../../utils/base";
import { Link } from "../../utils/customLink";
import { shareIcons } from "../../utils/shareIcons";
import VideoCard from "../cards/videoCard";
import Image from "../image";
import ParentInfoIntroDetails from "../parent-info/ParentInfoIntroDetails";
import ParentMainInfo from "../parent-info/parentMainInfo";
import CtaButton from "../shared/buttons/ctaButton";
import CollapsibleWrapper from "../shared/collapsibleWrapper";
import { ConditionalSwiper } from "../shared/conditionalSwiper";
import MobileGallery from "../shared/gallery/mobileGallery";
import GalleryBtnWithModal from "../shared/galleryBtnWithModal";
import VideoGrid from "../shared/videoGrid";

const ProgramFocusHeadInfo = ({
  headTitle,
  headSubtitle = "",
  programFeaturedVideo = "",
  gallery = [],
  locationSummary,
  genFeaturedVideos,
  openModal,
  setOpenModal,
  programCode,
  parentInformationDetails,
  sectionBgClass,
  genTestimonialVideos,
  featuredVideosDisplayCount = 2,
  baseLocations = [],
  layout = "std",
  formType = "parent_request",
  sectionContainerStyles = "px-4 py-10 md:pt-20 md:pb-10 md:px-0 bg-generic-bg",
  featureMapIllustration = false,
  hasCollapsibleWrapper = true,
  canShare = true,
  mobileGalleryClass = "mobile-gallery-section relative bg-transparent h-64 mt-8 w-full sm:hidden",
  ctaButtonClass = "px-7 text-base dark:text-sm font-semibold leading-7 tracking-wider gap-2 border",
  ctaIconClass = "fill-black-lighter group-hover:fill-black-lighter dark:fill-gray-darker dark:group-hover:stroke-green-standard dark:group-hover:fill-green-standard",
  showParentInfo = false,
  viewProgramCTAPreset = "primary",
  freeParentCTAPreset = "primary",
  freeParentArrowSize = "std",
  freeParentCTALabel = "Free parent consultation",
  freeParentBtnClass = "flex gap-2 items-center w-full md:w-max justify-center text-sm sm:text-base font-semibold leading-7 tracking-wider px-7",
  freeParentIconClass = "stroke-black-lighter group-hover:stroke-white"
}) => {
  const firstGalleryElement = gallery && gallery[0] ? gallery[0] : "";
  const colorMode = process.env.GATSBY_DEFAULT_THEME || "dark";
  const breakpoint = useBreakpoint();
  const [openShareWith, setOpenShareWith] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const shareWithMediaArr = shareIcons(shareUrl, headTitle);

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    setShareUrl(encodeURI(location?.href ?? "#"));
  }, []);

  const scrollToPrograms = () => {
    const programList = document.querySelector("#view-programs");
    programList?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const featuredVideoGallery =
    genFeaturedVideos?.slice(0, featuredVideosDisplayCount) ?? [];
  const featuredVideoGalleryCnt = featuredVideoGallery?.length;
  const imageGallery =
    featuredVideoGalleryCnt > 0
      ? gallery?.slice(
          1,
          parseInt(parseInt(4) - parseInt(featuredVideoGalleryCnt))
        )
      : gallery?.slice(1);
  const showGalleryIdxMarker =
    featuredVideoGalleryCnt > 0
      ? parseInt(parseInt(2) - parseInt(featuredVideoGalleryCnt))
      : 2;

  const testimonialVideos = genTestimonialVideos ?? [];
  const testimonialCollection = testimonialVideos?.map((testimonial, index) => {
    return {
      ...testimonial,
      cardClass: "h-102"
    };
  });

  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const hiddenFields = [{ fieldName: "program_id", fieldValue: programCode }];

  return (
    <>
      <section
        key={"head-info-section"}
        className={
          sectionBgClass
            ? sectionBgClass
            : `relative flex flex-col items-center justify-center px-4 py-10 sm:mx-auto sm:pt-20 sm:pb-10 sm:px-0 headinfo-section ${sectionContainerStyles}`
        }
      >
        {layout === "leftTest" ? (
          <Image
            imageAlt=""
            image={""}
            imageClass="absolute right-0 top-0 left-0 bottom-0 w-full h-full object-cover object-center hidden sm:block"
            sourceUrl={spiralBG}
          />
        ) : (
          <div className="md:flex hidden justify-end absolute top-0 right-0 md:w-[30vw]">
            {colorMode === "dark" && (
              <Image
                imageAlt=""
                image={""}
                imageClass="hidden object-cover object-center sm:dark:block"
                sourceUrl={LeafBg}
              />
            )}
          </div>
        )}

        <div className="sm:container flex flex-col w-full sm:w-4/5">
          <div className="flex flex-col sm:gap-10 md:flex-row">
            {layout === "std" && (
              <div className="relative w-full md:w-1/2 sm:w-full px-4 left-info-wrapper">
                {featureMapIllustration}

                <div className="relative">
                  <div className="flex justify-between">
                    <h1
                      className="font-normal dark:font-light text-section-title-text sm:pr-4"
                      dangerouslySetInnerHTML={{ __html: headTitle }}
                    />

                    <div
                      className={`flex flex-row items-start justify-between mt-4 border-t border-b md:mt-0 md:border-none border-t-gray-standard border-b-gray-standard ${
                        hasCollapsibleWrapper ? "" : "border-none"
                      }`}
                    >
                      <div className="relative items-center cursor-pointer justify-right hidden sm:block">
                        {!openShareWith && canShare && (
                          <div className="pr-4 sm:pr-0">
                            <ShareIcon
                              onClick={() => setOpenShareWith(!openShareWith)}
                              className={
                                " fill-black-lighter dark:fill-gray-generic  hover:dark:fill-white hover:fill-black-lighter opacity-60 hover:opacity-100 absolute"
                              }
                            />
                          </div>
                        )}
                        {openShareWith && canShare && (
                          <div className="flex">
                            <ul
                              className="flex flex-col gap-2 border border-gray-lighter rounded-xxxxl p-3 dark:bg-gray-dark bg-generic-bg absolute -ml-10 sm:-ml-4 -mt-2 sm:-mt-4 z-10"
                              style={{
                                boxShadow: "0px 4px 40px rgba(0, 0, 0, 0.25)"
                              }}
                            >
                              <li>
                                <ShareIcon
                                  onClick={() =>
                                    setOpenShareWith(!openShareWith)
                                  }
                                  className={
                                    "fill-black-lighter dark:fill-gray-generic hover:dark:fill-white hover:fill-black-lighter opacity-60 hover:opacity-100 w-5 h-5"
                                  }
                                />
                              </li>
                              {shareWithMediaArr &&
                                shareWithMediaArr.length > 0 &&
                                shareWithMediaArr.map((media, idx) => {
                                  return (
                                    <li key={`share-with-media-${idx}`}>
                                      {media.node}
                                    </li>
                                  );
                                })}
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {showParentInfo && parentInformationDetails && (
                    <ParentInfoIntroDetails
                      parentInformationDetails={parentInformationDetails}
                    />
                  )}

                  {headSubtitle?.length > 0 && (
                    <div className="flex flex-row items-start justify-between mt-4 border-t border-b md:mt-0 md:border-none border-t-gray-standard border-b-gray-standard py-3 sm:py-0">
                      <div className="flex flex-col w-full sm:w-2/3 justify-left md:w-9/12">
                        <h3
                          className="font-normal dark:font-light program-subtitle text-section-title-text"
                          dangerouslySetInnerHTML={{ __html: headSubtitle }}
                        />
                      </div>
                    </div>
                  )}

                  <div className="py-1 z-1">
                    {baseLocations && baseLocations.length > 0 && (
                      <div className="grid grid-cols-1 text-white md:grid-cols-2 program-locations">
                        <ConditionalSwiper
                          condition={breakpoint === "xs"}
                          slidesPerView={1.5}
                          spaceBetween={10}
                          centeredSlides={false}
                          className="w-full h-full"
                        >
                          {baseLocations &&
                            baseLocations.length > 0 &&
                            baseLocations.map((loc, index) => (
                              <div
                                key={`base-location-${index}`}
                                className="flex flex-row items-center w-full h-full px-8 py-2 cursor-pointer md:px-0
                            gvi-box-shadow rounded-xxs bg-black-lighter sm:w-max sm:h-auto md:bg-inherit md:shadow-none md:rounded-none"
                              >
                                <LocationIcon className="w-5 ml-auto location-icon sm:ml-0 fill-white md:fill-black-lighter dark:fill-white" />
                                <Link
                                  to={loc?.link ?? "#"}
                                  className="pl-4 mr-auto underline program-location fill-white md:text-black-lighter dark:text-white sm:mr-0"
                                >
                                  {loc.text}
                                </Link>
                              </div>
                            ))}
                        </ConditionalSwiper>
                      </div>
                    )}

                    <div className="py-4">
                      <CollapsibleWrapper
                        desc={locationSummary}
                        descStyle={`text-section-desc-text tab-content_html collapsible-wrapper`}
                        btnStyle="flex underline underline-offset-2 pt-2 text-generic-text font-lato dark:font-normal dark:text-white text-sm"
                        wrapperContainer="text-section-desc-text tab-content_html"
                        visibleLength={breakpoint === "xs" ? 350 : 30}
                        readMoreAdditionalStyle={"md:line-clamp-none"}
                        type={hasCollapsibleWrapper ? "both" : "mobile-only"}
                        readMoreBtnArrowStyle="ml-1 mt-2 stroke-black-lighter dark:stroke-white transition ease-in-out duration-300"
                        displayFullDesc={breakpoint === "xs" ? false : true}
                      />
                    </div>
                    <div className="w-full flex flex-col sm:flex-row gap-8 view-programs-link pt-8">
                      {showParentInfo && (
                        <>
                          <CtaButton
                            preset={freeParentCTAPreset}
                            arrowClass={`${freeParentIconClass}`}
                            extraButtonStyle={freeParentBtnClass}
                            arrowSize={freeParentArrowSize}
                            type="apply"
                            showAsButton={true}
                            ctaLabel={freeParentCTALabel}
                            onClick={() => {
                              setOpenModal(true);
                            }}
                          />
                        </>
                      )}

                      <CtaButton
                        preset={viewProgramCTAPreset}
                        arrowClass={ctaIconClass}
                        extraButtonStyle={ctaButtonClass}
                        type="down"
                        showAsButton={true}
                        ctaLabel={"View programs"}
                        onClick={scrollToPrograms}
                        labelClass={
                          "text-black-lighter dark:text-white group-hover:text-white dark:group-hover:text-black-lighter "
                        }
                      />
                    </div>

                    {showParentInfo && openModal && (
                      <ParentMainInfo
                        setOpenModal={handleCloseModal}
                        openModal={openModal}
                        displayInline={false}
                      />
                    )}
                  </div>
                </div>
              </div>
            )}

            {layout === "leftTest" && (
              <div className="relative w-full h-full sm:w-1/2 sm:pl-4 sm:px-4 left-info-wrapper">
                <VideoGrid
                  key={`featured-testimonial-video-grid`}
                  cardOption={"social"}
                  containerClass={"rounded-md block h-full"}
                  gridClass={"w-full grid-cols-1 sm:grid-cols-2 sm:gap-4"}
                  videos={testimonialCollection}
                  conditionalSliderOpts={{
                    condition: breakpoint === "xs",
                    slidesPerView: 1.15,
                    spaceBetween: 10,
                    centeredSlides: false,
                    className: "w-full h-full"
                  }}
                  extraSocialNameTextClass={
                    "font-alice dark:font-body font-semibold text-mob md:text-xl text-black-lighter dark:text-white col-span-5"
                  }
                  extraSocialDateTextClass={
                    "font-alice dark:font-body font-light text-xs text-black-lighter dark:text-white"
                  }
                />
              </div>
            )}
            <div
              className={`relative w-full pt-0 md:w-1/2 right-gallery-wrapper sm:pt-0 ${
                layout === "leftTest" ? "hidden sm:block" : "sm:block"
              }`}
            >
              {breakpoint && breakpoint === "xs" && gallery?.length > 0 ? (
                <MobileGallery
                  containerClass={mobileGalleryClass}
                  gallery={gallery}
                  featuredSingleVideo={programFeaturedVideo}
                  videoGallery={featuredVideoGallery}
                />
              ) : (
                <div className="grid grid-cols-2 grid-rows-2 gap-2 md:grid-cols-3 md:gap-4 program-gallery md:grid-rows-[400px_120px]">
                  <div
                    className="relative md:h-full h-[40vw] overflow-hidden text-white bg-transparent bg-center bg-no-repeat bg-cover rounded-md project-video"
                    style={{
                      gridColumn: "1/4",
                      backgroundImage: `url(${getSourceImageUrlToCGI({
                        uri: encodeURI(
                          firstGalleryElement?.localFile &&
                            firstGalleryElement?.localFile?.publicURL
                            ? firstGalleryElement.localFile?.publicURL
                            : firstGalleryElement?.sourceUrl
                        )
                      })})`
                    }}
                    dangerouslySetInnerHTML={{ __html: programFeaturedVideo }}
                  />
                  <div className="grid grid-cols-3 sm:grid-cols-3 gap-2 md:gap-4 col-span-full auto-rows-auto">
                    {featuredVideoGallery &&
                      featuredVideoGallery.map((videos, idx) => {
                        const video = videos.genVideoUrl;
                        return (
                          <VideoCard
                            key={`vide-card-gallery-${idx}`}
                            featVideos={video}
                            cardClass="relative bg-center bg-no-repeat bg-cover rounded-md sm:h-full grid-row-span-1 h-full py-1"
                          />
                        );
                      })}

                    {imageGallery && (
                      <>
                        {imageGallery.length > 0 &&
                          imageGallery.map((galleryItem, idx) => {
                            if (idx < showGalleryIdxMarker)
                              return (
                                <div
                                  key={`image-gallery-gitem-${idx}`}
                                  className="bg-center bg-no-repeat bg-cover rounded-md grid-row-span-1 md:h-auto h-[32vw]"
                                  data-temp={idx + " - " + breakpoint}
                                  style={{
                                    backgroundImage: `url(${getSourceImageUrlToCGI(
                                      {
                                        uri: encodeURI(
                                          galleryItem?.localFile &&
                                            galleryItem?.localFile?.publicURL
                                            ? galleryItem?.localFile?.publicURL
                                            : galleryItem?.sourceUrl
                                        )
                                      }
                                    )})`
                                  }}
                                  data-id={`image-gallery-gitem-${idx}`}
                                />
                              );
                            else if (idx === showGalleryIdxMarker)
                              return (
                                <div
                                  key={`show-gallery-marker-gitem-${idx}`}
                                  className="relative md:h-auto h-[32vw] bg-center bg-no-repeat bg-cover rounded-md"
                                  style={{
                                    backgroundImage: `url(${getSourceImageUrlToCGI(
                                      {
                                        uri: encodeURI(
                                          galleryItem?.localFile &&
                                            galleryItem?.localFile?.publicURL
                                            ? galleryItem?.localFile?.publicURL
                                            : galleryItem?.sourceUrl ??
                                                galleryItem?.type
                                        )
                                      }
                                    )})`
                                  }}
                                >
                                  <div
                                    key={`show-gallery-marker-gitem-child-${idx}`}
                                    className="relative w-full hidden sm:block md:absolute program-gallery-more bottom-14 md:bottom-4 "
                                  >
                                    <GalleryBtnWithModal
                                      key="gallery-btn-modal"
                                      galleryPhotos={gallery}
                                      featVideo={programFeaturedVideo}
                                      programFeaturedVideoTestimonials={
                                        genFeaturedVideos
                                      }
                                    />
                                  </div>
                                </div>
                              );
                            else return <></>;
                          })}
                      </>
                    )}
                  </div>

                  {imageGallery.length > 0 && (
                    <div
                      className={"w-full mx-auto flex col-span-full sm:hidden"}
                    >
                      <GalleryBtnWithModal
                        galleryPhotos={gallery}
                        featVideo={programFeaturedVideo}
                        programFeaturedVideoTestimonials={genFeaturedVideos}
                        extraButtonClass={"w-full"}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProgramFocusHeadInfo;
